// @ts-ignore
import * as cart from '@shopify/theme-cart';
import { CartResponse } from '../types/Cart';

export default async function handleCartGetState(): Promise<CartResponse> {
  return await (cart.getState() as CartResponse)
    .catch(err => {
      return err;
    });
}
